export default __webpack_public_path__ + "static/media/42_mobile.df6a4a15.jpg";